module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMA8u74FNfIQ+TPh0k8N+ng0sCuqZuZcGNfU0QtHgU5iNB/AAAAcklEQVQY04XMVw6FMBBDUU+GJLTXe5v9L/NBhAQEI+7nkWVM+hzLGsu8mV0WWljfLudn4nvOVeJHpi+bnxRdwFeT+gGbg6rK9b231LmNMbaAGOkENRYcU+Hsttfb3xXnG+dA2TWUPWCsH4L0uVDKWI2V/pGmIrRmIEMfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew/profile/icon-like.png
// module id = +KLb
// module chunks = 1